<template>
  <div v-if="uniqueAccessCode && !canShowPresentingScreen" class="w-full h-full">
    <iframe
      :src="audienceLink"
      class="sharable-iframe audience-iframe"
    />
  </div>
</template>
<script>
import { app } from '@microsoft/teams-js'
import { mapState } from 'vuex'
import config from '@/config'
import cookie from '@/services/cookie'
import msTeamsUtils from '@/utils/ms-teams'
import util from '@/util'

export default {
  data() {
    return {
      uniqueAccessCode: null,
      presentationConfig: null,
      frameContext: null,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    audienceLink() {
      if (!this.uniqueAccessCode) return null
      const isMeeting = util.getParamValue('context', window.location.href) === 'meeting'
      return `${config.audienceHttpsEndpoint}/${this.uniqueAccessCode}${isMeeting ? '?ms_teams=true&dark-theme=true' : ''}`
    },

  },
  async mounted() {
    const isLoggedIn = !!cookie.getValue('ahaToken')

    const context = await app.getContext()
    const frameContext = app.getFrameContext()
    this.frameContext = frameContext

    const entityId = util.getParamValue('entityId', window.location.href)
    const presentContext = util.getParamValue('context', window.location.href)
    const presentationConfig = msTeamsUtils.decodeEntityId(entityId)
    this.presentationConfig = presentationConfig

    const {
      id, uniqueAccessCode, msTeamsUserId, ahaslidesUserId,
    } = presentationConfig

    const isTheSameMSTeamsUser = context.user.id === msTeamsUserId
    const isTheSameAhaSlidesUser = this.currentUser && ahaslidesUserId &&
        ahaslidesUserId == this.currentUser.id
    this.canShowPresentingScreen =
      isLoggedIn &&
      (isTheSameMSTeamsUser || isTheSameAhaSlidesUser) &&
      frameContext === 'content'
    /** FOR PRESENTER */
    if (this.canShowPresentingScreen) {
      this.$router.replace({
        name: 'PresentationDetail',
        params: { id },
        query: { presenting: true, 'ms-teams': true, context: presentContext },
      })
      return
    }

    /** FOR PARTICIPANTS */
    this.uniqueAccessCode = uniqueAccessCode
  },
}
</script>

<style lang="scss">
.sharable-iframe {
  width: 100vw;
  height: 100vh;
}
</style>
